import { render } from "./SalesValue.vue?vue&type=template&id=9203c0f6"
import script from "./SalesValue.vue?vue&type=script&lang=js"
export * from "./SalesValue.vue?vue&type=script&lang=js"

import "./SalesValue.vue?vue&type=style&index=0&id=9203c0f6&lang=css"

import exportComponent from "C:\\Users\\msimi\\Downloads\\tuaszone\\survey-agel-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__